import { render, staticRenderFns } from "./ERPIntegrationSettingRow.vue?vue&type=template&id=2c6118fe&scoped=true&"
import script from "./ERPIntegrationSettingRow.vue?vue&type=script&lang=js&"
export * from "./ERPIntegrationSettingRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6118fe",
  null
  
)

export default component.exports